module.exports = __webpack_public_path__ + "static/img/tutorial-report-2.d55ce4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tutorial-report-2.jpg
// module id = 64nW
// module chunks = 3